import React from 'react';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';
import { CitizenNameDisplay } from '../../../../components/display/citizen-name-display';

export type CourseEnrollmentTitleMode = 'create' | 'edit' | 'view';

const titles: Record<CourseEnrollmentTitleMode, string> = {
  create: 'Opret fremmødeforløb',
  edit: 'Redigér fremmødeforløb',
  view: 'Fremmødeforløb - Annulleret',
};

export interface ICourseEnrollmentTitlezoneProps {
  mode: CourseEnrollmentTitleMode;
}

export function CourseEnrollmentTitlezone(props: ICourseEnrollmentTitlezoneProps) {
  const { mode } = props;
  return <PageTitleZoneNext isLoading={false} entityName="Fremmødeforløb" title={titles[mode]} subtitle={<CitizenNameDisplay />} />;
}

export function getCourseEnrollmentTitleMode(isEditMode: boolean, isActive?: boolean): CourseEnrollmentTitleMode {
  if (!isEditMode) {
    return 'create';
  }

  return isActive ? 'edit' : 'view';
}
